import { TypeOf, object, string } from "zod";

const bankSchema = object({
  code: string().nonempty("Banco é obrigatório"),
  agency: string().nonempty("Agência é obrigatório"),
  accountNumber: string().nonempty("Conta é obrigatório"),
});

type BankInput = TypeOf<typeof bankSchema>;

export type { BankInput };

export { bankSchema };
